import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import SubNav from 'main/containers/company_settings/SubNav';
import {Panel, Layout} from 'shared/components';
import {
  EditVisibilitySettingModal,
  VisibilityPreferenceToggle,
  VisibilitySettingsState
} from 'main/components/visibility_settings';

const VisibilitySettingsContainer = observer(({uiState}) => {
  const {staffCount, peopleDirectory} = uiState;

  return (
    <div>
      <SubNav title={t('company_settings.subnav.Visibility Preferences')} toolbar={
        <div className='inline-block'>
        </div>
      }/>
      <Layout>
        <Panel.Stack loose>
          <Panel>
            <Panel.Header title={t('company_settings.visibility_settings.People Directory Visibility Preferences')} />
            <VisibilityPreferenceToggle uiState={uiState} setting={peopleDirectory}/>
          </Panel>
          <Panel>
            <Panel.Header title={t('company_settings.visibility_settings.Home Page Visibility Preferences')} />
            <VisibilityPreferenceToggle uiState={uiState} setting={staffCount}/>
          </Panel>
        </Panel.Stack>
      </Layout>
      <EditVisibilitySettingModal uiState={uiState}/>
    </div>
  );
});

export default withState(VisibilitySettingsContainer, VisibilitySettingsState);
